import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { manuals } from '../data/content';
export function Manuals() {
  return <section className="border-t border-ink-700 bg-ink-950 px-4 py-12 sm:px-6 sm:py-16" data-id="element-176" data-mp="32iw5f0bdcuy0">
      <div className="mx-auto w-full max-w-4xl" data-id="element-177" data-mp="32h1ijggjesra">
        <SectionHeading eyebrow="Alles, was enthalten ist" title="Die 6 Meister-Handbücher" data-id="element-178" data-mp="37j0omy3nw3rx" />

        <ol className="mt-8 space-y-3" data-id="element-179" data-mp="3v831ztr9jagm">
          {manuals.map(manual => <li key={manual.number} className="flex gap-4 rounded-2xl border border-ink-700 bg-ink-800 p-4 sm:p-5" data-id="element-180" data-mp="407dst29pt1g">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand font-display text-xl text-ink-950" data-id="element-181" data-mp="3q8gorkbfpu7t">
                {manual.number}
              </span>
              <div className="min-w-0" data-id="element-182" data-mp="29wjozm7ghe30">
                <h3 className="font-display text-lg uppercase leading-tight text-white sm:text-xl" data-id="element-183" data-mp="2eucwqjoeqg5e">
                  {manual.title}
                </h3>
                <p className="mt-1.5 text-[15px] leading-snug text-white/65" data-id="element-184" data-mp="1wjlq82gdzjoo">{manual.text}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock label="Ich will die 6 Handbücher" showTimer={false} note="Digitaler Zugang direkt nach der Zahlung" className="mt-8" data-id="element-185" data-mp="25j8jg0yypj6n" />
      </div>
    </section>;
}